import type { ApiError } from "@sperrdatei/dto/types";

type WithResponseOptions<T extends object, S> = {
  onSuccess: (data: T) => Promise<S>;
  onFailure: (error: ApiError) => Promise<ApiError>;
};

export const withResponse = async <T extends object, S>(
  response: Response,
  { onSuccess, onFailure }: WithResponseOptions<T, S>,
): Promise<S | ApiError> => {
  const contentType = response.headers.get("content-type");
  const isJson = contentType && contentType.includes("application/json");

  if (response.ok) {
    if (isJson) {
      const data = await response.json();
      return onSuccess(data);
    }

    const data = await response.text();
    return onSuccess(data as unknown as T);
  }

  if (isJson) {
    const error = await response.json();
    return onFailure(error);
  }

  return onFailure({
    code: response.status.toString(),
    message: response.statusText,
  });
};
